
export type TemplateColors = Record<string, string>;

export interface ITemplateColorDefinition {
    colors: TemplateColors;
    // maps a current colour key to the key it was saved under before the rename, so existing websites keep their colours
    legacy_color_keys?: Record<string, string>;
}

/**
 * Resolves the colours a template should render with: the `ds_colors` preview query param wins, then the website's saved
 * scheme colours (by current key, falling back to the legacy key) and finally the template definition's defaults.
 */
export function resolveTemplateColors(definition: ITemplateColorDefinition, savedColors?: TemplateColors, searchParams?: URLSearchParams): TemplateColors {
    const preview = searchParams?.get("ds_colors");
    const stored: TemplateColors = preview?.length ? JSON.parse(preview) : (savedColors ?? {});
    return Object.keys(definition.colors).reduce((acc, key) => {
        const legacyKey = definition.legacy_color_keys?.[key];
        acc[key] = stored[key] ?? (legacyKey ? stored[legacyKey] : undefined) ?? definition.colors[key];
        return acc;
    }, {} as TemplateColors);
}
